import { combineReducers } from 'redux'
import product from './product'
import services from './services'
import common from './common'

export default combineReducers({ product, services, common })
